export default "__VITE_ASSET__d87ff596__"